export enum AiModelTypes
{
    IMAGE = 'image',
    TEXT = 'text',
    EMBEDDING = 'embedding',
    TTS = 'tts',
    VISION = 'vision'
}
